import { Dispatcher as BaseDispatcher } from '../../../../_common/platform/ts/BaseDispatcher';

export class AppDispatcher extends BaseDispatcher {
    /**
     * A bridge function between the views and the dispatcher, marking the action
     * as a view action.  Another variant here could be handleServerAction.
     */
    public handleViewAction<T>(action: T) {
        //console.log('Action: ' + JSON.stringify(action));

        this.dispatch({
            source: 'VIEW_ACTION',
            action: action
        });
    }

    public static get() {
        return new AppDispatcher();
    }
}
